import React, { PropsWithChildren } from 'react';

// Utilities
import extendClassNameWithModifier from '../../../lib/bemUtils/bem';

// Shapes
import { FlagModifier } from './Flag.modifier';

type FlagProps = PropsWithChildren<{ modifier?: FlagModifier.MARGIN | FlagModifier.LIGHT }>;

export function Flag({ children, modifier }: FlagProps) {
  return <strong className={extendClassNameWithModifier('flag', modifier)}>{children}</strong>;
}
